import { render, staticRenderFns } from "./OrderProductionStatusLabel.vue?vue&type=template&id=4553d20c&scoped=true&"
import script from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductionStatusLabel.vue?vue&type=style&index=0&id=4553d20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553d20c",
  null
  
)

export default component.exports